<form [formGroup]="form">
  <title mat-dialog-title>Add Rule To {{ data.camera.name }}</title>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
    <button
      mat-button
      color="success"
      class="scheduleButton"
      type="button"
      (click)="openAiSchedulerDialog()"
    >
      Define Schedule
    </button>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" mat-dialog-close type="button">Close</button>
    <button [disabled]="form.invalid" mat-button color="success" (click)="submitForm()">
      Save
    </button>
  </mat-dialog-actions>
</form>
